import Axios from "axios";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import AlertError from "../../components/ui/error/AlertError";
import AlertSuccess from "../../components/ui/error/AlertSuccess";
import generateReferenceID from "../../utils/generateReferenceID";

const {
  REACT_APP_PAYMENT_URL: paymentUrl,
  REACT_APP_PAYMENT_NAME: paymentName,
  REACT_APP_PAYMENT_KEY: paymentKey,
  REACT_APP_PAYMENT_MERCHANT_ID: merchantID,
  REACT_APP_PAYMENT_MERCHANT_NAME: merchantName,
} = process.env;

const Pairing = () => {
  const [serialNo, setSerialNo] = useState("");
  const [message, setMessage] = useState("");
  const registerID = generateReferenceID();

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      let url = `${paymentUrl}/api/v2/pair/${paymentName}/${paymentKey}`;
      const res = await Axios.post(url, {
        serial_no: serialNo,
        merchant_id: merchantID,
        register_id: registerID,
        merchant_name: merchantName,
      });
      setMessage(res.data?.result || res.data?.final_message);
      localStorage.setItem("registerId", JSON.stringify(registerID));
    } catch (err) {
      console.log(err);
      setMessage(err?.response?.data?.message || err?.message);
    }
  };

  let content = "";
  if (message.toLowerCase() === "success" || message === "pairing successful")
    content = (
      <>
        <AlertSuccess message={message} />
        <div className="mt-4">
          <Link
            to="/"
            className="block p-4 mb-4 text-sm text-white bg-green-700 rounded-lg"
          >
            Back To Home
          </Link>
        </div>
      </>
    );
  else content = <AlertError message={message} />;

  return (
    <div className="col-span-1 p-10 bg-custom-blue-700 rounded-xl">
      <div className="m-0">
        <form onSubmit={submitHandler}>
          <p className="font-medium font-lg uppercase">Pairing Input</p>
          <div className="mt-12 mb-16">
            <label htmlFor="serialNo">Serial No:</label>
            <input
              id="serialNo"
              type="text"
              className="ml-3 mt-4 px-2 py-1.5 border border-white rounded w-full"
              required={true}
              onChange={(e) => setSerialNo(e.target.value)}
            />
          </div>

          <div className="text-right">
            <button
              type="submit"
              className="px-2.5 py-2 bg-custom-blue-600 text-black rounded-lg uppercase font-semibold"
            >
              Pair Terminal
            </button>
          </div>
          {message && <div className="ml-3">{content}</div>}
        </form>
      </div>
    </div>
  );
};

export default Pairing;
